import SkapaAccordion, {
  type AccordionProps,
  AccordionItem as SkapaAccordionItem,
  type AccordionItemProps as SkapaAccordionItemProps,
} from "@ingka/accordion";

export type AccordionItemProps = SkapaAccordionItemProps &
  React.RefAttributes<HTMLLIElement>;

export const Accordion = (props: AccordionProps) => {
  return <SkapaAccordion prefix="saleslead__" {...props} />;
};

export const AccordionItem = (props: AccordionItemProps) => {
  return (
    <SkapaAccordionItem prefix="saleslead__" {...props}>
      {props.children}
    </SkapaAccordionItem>
  );
};
